import type { Backend } from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import type { UserTaxInfoCollection } from './user-tax-info.types';

export function userTaxInfoBackend(): Backend<UserTaxInfoCollection> {
  return {
    defaultOrder: {
      field: 'id',
      direction: OrderByDirection.ASC,
    },
    fetch: (authUid, ids, query, order) => ({
      endpoint: 'users/0.1/self/tax',
      params: {
        country_code: getQueryParamValue(query, 'countryCode')[0],
        types: getQueryParamValue(query, 'type'),
      },
    }),
    push: (authUid, tax) => ({
      method: 'POST',
      endpoint: 'users/0.1/self/tax',
      payload: {
        type: tax.type,
        us_tax_subtype: tax.usTaxSubtype,
        country_code: tax.countryCode,
        number: tax.number,
        name: tax.name,
      },
    }),
    set: (authUid, tax) => ({
      // This method is a helper function to be able to replace the currently
      // existing user tax information. This should only be used for tax types
      // that should have 1 tax information at most for a user.
      method: 'POST',
      endpoint: 'users/0.1/self/tax',
      payload: {
        type: tax.type,
        us_tax_subtype: tax.usTaxSubtype,
        country_code: tax.countryCode,
        number: tax.number,
        name: tax.name,
      },
    }),
    update: undefined,
    remove: (authUid, taxId) => ({
      method: 'DELETE',
      endpoint: `users/0.1/self/tax/${taxId}`,
      payload: {},
    }),
  };
}
